import Form from './TermsForm'
import isEmpty from './TermsIsEmpty'
import Section from './TermsSection'
import Thumbnail from './TermsThumbnail'

export default { Form, isEmpty, Section, Thumbnail }
